import { request } from '@/shared/api/request'

export const getBankByAccount = (params) => {
	return request({ url: 'contract/oopv/getBankByAccount', method: 'GET', params })
}
